define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/comm",
	"csi/resolver",
	"csi/session",
	"csi/xml"
], function(declare,Controller,comm,resolver,session,xml) {

	return declare(Controller, {
		_templateURL: null,

		getFormData: function() {
			// summary: prevent the editability of the Node Name field in the pop-up form
			// from tracking that of the WBS Node Name
			var fd = this.inherited(arguments);
			fd.setNode(null);
			return fd;
		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: navigating to new template, but breadcrumb needs update to WbsAdmin node to properly render
			urlsNew.push("centric://REFLECTION/INSTANCE/WbsAdmin/BLANK");
			return this.inherited(arguments);
		},

		toWriterRequest: function() {
			// summary: supply the URL for the new template to the server operation
			this._templateURL = comm.createUrl("Wbs");
			return this.inherited(arguments).addParameter("TemplateURL", xml.ATTR_CNL, this._templateURL);
		},

		postProcessSuccess: function() {
			// summary: navigate to new node
			session.setLocationUrl(this._templateURL, true);
		}
	});
});